export interface itsItem {
    key: string;
    label?: string;
    description?: string;
    table?: boolean;
    width?: number;
    xlsx?: boolean;
    hidden?: boolean;
    edit?: boolean;
    add?: boolean;
    pdf?: boolean;
    newValues?: boolean;
    selectValues?: SelectValues[]
    type?: 'text' | 'number' | 'textarea' | 'date' | 'select'| 'file';
}

interface SelectValues {
    value: string
    label: string
}

interface IStateItemAssets {
    its: itsItem[];
    infrastructure: any[];
    edification: any[];
    environment: any[];
}

export const initialState: IStateItemAssets = {
    its: [
        { key: '#', label: '#', description: '', table: true, width: 10 },
        { key: 'type_id', label: 'Tipo de elemento', description: '', table: true, hidden: true, width: 15 },
        // { key: 'code', label: 'ID Registro', description: '', table: true, edit: true, add: true, type: 'text', width: 15, xlsx: true, pdf: true },
        { key: 'km', label: 'Cadenamiento', description: '', table: true, edit: true, add: true, type: 'number', width: 15, xlsx: true, pdf: true },
        { key: 'direction', label: 'Sentido', description: '', table: true, edit: true, add: true, type: 'text', width: 15, xlsx: true, pdf: false },
        { key: 'body', label: 'Cuerpo', description: '', table: true, edit: true, add: true, type: 'text', width: 15, xlsx: true, pdf: true },
        { key: 'latitude', label: 'Latitud', description: '', table: true, edit: true, width: 15, xlsx: true },
        { key: 'longitude', label: 'Longitud', description: '', table: true, edit: true, width: 15, xlsx: true },
        { key: 'assets_base_line_id', label: 'Línea base', description: '', table: true, width: 15, xlsx: true },
        { key: 'check_status', label: 'Estado', description: '', table: true, width: 20, xlsx: true, pdf: true },
        { key: 'type_name', label: 'Tipo de Elemento', description: '', width: 20, xlsx: true, pdf: true },
        { key: 'id', label: 'ID', description: '', width: 10, xlsx: true },
        { key: 'project_id', label: 'ID Autopista', description: '', hidden: true, width: 15 },
        { key: 'segment_id', label: 'Segmento', description: '', hidden: true, width: 15, xlsx: true, pdf: true },
        { key: 'tollbooth', label: 'Plaza', description: '', edit: true, add: true, type: 'text', width: 15, xlsx: true, pdf: false },
        { key: 'description', label: 'Descripción', description: '', edit: true, add: true, type: 'text', width: 30, xlsx: true },
        { key: 'altitude', label: 'Altitud', description: '', edit: true, width: 15, xlsx: true },
        { key: 'others', label: 'Otros', description: '', edit: true, add: true, type: 'textarea', width: 15, xlsx: true },
        { key: 'created_at', label: 'Creado en', description: '', width: 30, xlsx: true },
        { key: 'updated_at', label: 'Actualizado en', description: '', width: 30, xlsx: true },
        { key: 'removed', label: 'Visibilidad', description: '', hidden: true, width: 15 },
        { key: 'extra', label: 'Valores Adicionales', description: '', hidden: true, width: 40, xlsx: true },
        { key: 'component_id', hidden: true },
        { key: 'monitoring_id', hidden: true },
        /* CAMPOS EXTRAS */
        { key: 'purchase_date', label: "Fecha de compra", edit: true, add: true, type: 'date', newValues: true },
        { key: 'invoice_file', label: "Factura (pdf)", edit: true, add: true, type: 'file', newValues: true },
        { key: 'supplier_name', label: "Proveedor", edit: true, add: true, type: 'text', newValues: true },
        { key: 'warranty_expiration_date', label: "Expiración de la garantía", edit: true, add: true, type: 'date', newValues: true },
        { key: 'useful_life_value', label: "Tiempo de vida (Valor ej: 2)", edit: true, add: true, type: 'number', newValues: true },
        { key: 'useful_life_unit', label: "Tiempo de vida (Unidad ej: Días)", edit: true, add: true, type: 'select', newValues: true, selectValues: [
            { label: "Minutos", value: "minute"},
            { label: "Horas", value: "hour"},
            { label: "Días", value: "day"},
            { label: "Semanas", value: "week"},
            { label: "Meses", value: "month"},
            { label: "Años", value: "year"},
        ]},
        { key: 'maintenance_period', label: "Período de mantenimiento", edit: true, add: true, type: 'select', newValues: true, selectValues: [
            { label: "Diario", value: "diary"},
            { label: "Semanal", value: "weekly"},
            { label: "Mensual", value: "monthly"},
            { label: "Trimestral", value: "quarterly"},
        ]},
    ],
    infrastructure: [],
    edification: [],
    environment: []
}